import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Augustin Ursu
 * id 5A1815F9-FC9E-4420-B723-AF4B324262A4
 * name toilet
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toilet.svg
 * tags
 * - Home Automation 
 */
export const ToiletIcon = createSvgIcon(<><path d="M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4A2,2 0 0,0 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22M5.29,14H18.71C18.14,15.91 16.77,17.5 15,18.33V20H11V18.33C9,18 5.86,15.91 5.29,14M15,4H19V12H15V4M16,5V8H18V5H16Z" /></>, 'ToiletIcon');
export default ToiletIcon